export const projects = [
    {
        "image": require("../../images/new-invoice.webp"),
        "author":"Mavhungu Ronewa",
        "title":"Ronewa Pay Application",
        "description": "Developed this application using Angular and NestJS. The application allows users to create invoices and manages them. User can subscribe to the application and make/receive payments using Stripe",
        "link":"teams",
        "github":"#",
        "web-link":"https://ronewa-pay.netlify.app"
    },
    {
        "image": require("../../images/new-wego.webp"),
        "author":"Mavhungu Ronewa",
        "title":"Wego Enviro Solutions",
        "description": "I developed this website using HTML, CSS and JavaScript. The website is for a company that provides waste management services. The website allows users to learn more about the company and its services, as well as contact the company for more information.",
        "link":"medicine",
        "github":"#",
        "web-link":"https://wegoenviro.com"
        
    },
    {
        "image": require("../../images/wegowaste.png"),
        "author":"Mavhungu Ronewa",
        "title":"Waste Management System",
        "description": "App that allows users to schedule upcoming task and interact with other users. Developed using NodeJS and MongoDB",
        "link":"schedule",
        "github":"https://gitlab.com/ronewagilbert3/wego-enviro-medical-waste",
        "web-link":"#"
    },
    {
        "image": require("../../images/dose_tracker.webp"),
        "author":"Mavhungu Ronewa",
        "title":"Medication dose Tracker",
        "description": "I developed this application using React, NodeJS and MongoDB. The application allows users to track their medication doses and receive reminders when it's time to take their medication. The application also allows users to share their medication schedule with their healthcare provider.",
        "link":"wego",
        "github":"https://github.com/mavhungu/Medicine-dose-tracker-web-app",
        "web-link":"http://ronewa-medicine-tracker.herokuapp.com"
    },
]
